import { useEffect, useState } from "react";
import { Bell } from "lucide-react";

// A transient top-of-page banner for "you have a new message" - shows for a
// couple of seconds, then animates up and to the right (toward the bell
// icon, which always lives in the top-right corner on both breakpoints)
// shrinking and fading out, approximating "flying into" the bell rather
// than tracking its exact on-screen position.
export default function NewMessageRibbon({ message, onDone }) {
  const [flying, setFlying] = useState(false);

  useEffect(() => {
    const flyTimer = setTimeout(() => setFlying(true), 2500);
    const doneTimer = setTimeout(() => onDone(), 3200);
    return () => {
      clearTimeout(flyTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div
      className={`fixed top-4 inset-x-0 z-[100] flex justify-center pointer-events-none transition-all ease-in ${
        flying ? "duration-700 opacity-0 scale-0 -translate-y-1 translate-x-[42vw]" : "duration-300"
      }`}
    >
      <div className="flex items-center gap-2 bg-slate-900 text-white pl-3 pr-4 py-2.5 rounded-full shadow-2xl ring-1 ring-white/10 animate-in slide-in-from-top-4 fade-in duration-300">
        <Bell size={16} className="shrink-0 text-amber-400 animate-bounce" />
        <span className="text-sm font-semibold whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}
